import React from 'react';
import { Form, Input, Button, Space } from 'antd';
import { SaveOutlined } from '@ant-design/icons';

// 创建对象
const TeamData = () => {

}

TeamData.teamNo = () => {
    const rules = [
        {
            required: true,
            message: '请输入团队号',
        },
        {
            max: 50,
            message: '最长50位',
        },
    ];

    return (
        <Form.Item name="teamNo" rules={rules} label="团队号">
            <Input size="middle" placeholder="请输入团队号" />
        </Form.Item>
    );
}

TeamData.teamName = () => {
    const rules = [
        {
            required: true,
            message: '请输入名称',
        },
        {
            max: 50,
            message: '最长50位',
        },
    ];

    return (
        <Form.Item name="teamName" rules={rules} label="名称">
            <Input size="middle" placeholder="请输入名称" />
        </Form.Item>
    );
}

TeamData.teamDesc = () => {
    const rules = [
        {
            max: 2000,
            message: '最长2000位',
        },
    ];

    return (
        <Form.Item name="teamDesc" rules={rules} label="简介">
            <Input.TextArea placeholder="请输入简介" rows="10" />
        </Form.Item>
    );
}

TeamData.SaveButton = ({ onCancel, onSave }) => {
    return (
        <Space>
            <Button size="middle" onClick={onCancel}>取消</Button>
            <Button htmlType="submit" type="primary" size="middle" icon={<SaveOutlined />} onClick={onSave}>保存</Button>
        </Space>
    );
}

export default TeamData;